
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerSquare as ObiBeaconTowerSquareElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-square.js';
 
 
 

 
 export const ObiBeaconTowerSquare = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-square',
   elementClass: ObiBeaconTowerSquareElement,
   events: {
     
   }
  });
 
 